<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          اسلایدر
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field outlined dense label="شرح" v-model="description"/>
          </v-col>
          <v-col cols="12" sm="4">
            <v-file-input outlined :error-messages="getError('file')" label="انتخاب عکس" dense v-model="file" />
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn small block  depressed color="primary" @click="save(1)"> ثبت</v-btn>
          </v-col>
        </v-row>

        <v-spacer/>
        <show-img :model="model" :dialog-status.sync="dialogStatus"/>
        <b-table
            v-if="can('sliderList')"
            :items="dataItems"
            :fields="columns"
            stacked="md"
            show-empty
            responsive
            striped
        >
          <template #cell(actions)="row">
            <v-btn depressed class="mr-1" v-if="can('deleteSlider')" small color="primary" @click="forShow(row.item)">
              مشاهده
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteSlider')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Slider_se from "./Slider_se";
import ShowImg from "./ShowImg";
import {mapMutations} from "vuex";

export default {
  name: 'Slider',
components:{
    ShowImg
},
  data() {
    return {
      dialogStatus:false,
      description: '',
      file: [],
      dataItems: [],
      model:{},
      bindingErrors: [],
      columns: [
        {key: 'caption', label: 'شرح', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },


  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    forShow(e) {
     this.model=e
      this.dialogStatus=true
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },


    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Slider_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    save(id) {
      Slider_se.save(this.description, this.file, id).then(response => {
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.fillDataItems()
          this.description = ''
          this.file = []
        } else if (response && response.response.status === 400) {
          this.bindingErrors = response.response.data;
        }
      })
    },

    fillDataItems() {
      Slider_se.getPage().then(response => {
        this.dataItems = response.data.list
      });
    },

  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
